import { render, staticRenderFns } from "./simpleForm.vue?vue&type=template&id=b894fb5c&scoped=true&lang=pug&"
import script from "./simpleForm.vue?vue&type=script&lang=js&"
export * from "./simpleForm.vue?vue&type=script&lang=js&"
import style0 from "./simpleForm.vue?vue&type=style&index=0&id=b894fb5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b894fb5c",
  null
  
)

export default component.exports